
import { Component, OnInit,Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data,
  public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
  public dialog: MatDialog){
    dialogRef.disableClose = true;
  }
  closeDialog(){
    this.dialogRef.close(false);
    document.getElementById('showYesDialog').style.display = "none";
  }
  saveDialog() {
    this.dialogRef.close(true);
    document.getElementById('showYesDialog').style.display = "none";
  }

  ngOnInit() {
    //onInit
  }

}
